import React from 'react'
// import { Carousel } from 'antd-mobile-v2'
import { Swiper } from 'antd-mobile'
import { handleCovertPhone } from '../../../utils'
import CardGameIcon from '../../../assets/xiniu/card_game/card-game-icon.png'

class CardGameCarousel extends React.PureComponent {
  state = {
    // data: []
    data: [
      // {id: '1',covertPhone: '123asd', giftDesc: 'asdb' }
    ]
  }
  getData = () => {
    let config = {
      url: window.API.CardGame.getLotteryUser,
      params: {
        pageIndex: 1,
        pageSize: 10
      }
    }
    window.axios.request(config)
      .then(res => {
        this.setState({
          data: res.map(item => {
            return {
              covertPhone: handleCovertPhone(item['phone']),
              ...item
            }
          })
        })
      })
      .catch((e) => {console.error(e)})
  }

  componentDidMount () {
    this.getData()
  }

  render () {
    const { data } = this.state
    return <div className={'card-game__carousel card-game__carousel--xiniu'}>
      <img src={CardGameIcon} className={'card-game__carousel__icon'} alt=""/>
      {
        data.length > 0
          ? <Swiper
            direction={'vertical'}
            indicator={false}
            allowTouchMove={false}
            autoplay
            loop
          >
            {data.map(item => {
              return <Swiper.Item key={item['id']}>
                <div className="card-game__carousel__item">恭喜 {item['covertPhone']} 获得 {item['giftDesc']}</div>
              </Swiper.Item>
            })}
          </Swiper>
          : null
      }
    </div>
  }
}

export default CardGameCarousel
